// extracted by mini-css-extract-plugin
export default {"wrapper":"WD-z","viewport":"XD-z","container":"YD-z","slide":"ZD-z"};